import { DEFAULT_LOCALE, stripLocaleFromPathname } from './locale';

const FULLY_TRANSLATED_PREFIXES = [
    '/',
    '/services/vps-kvm',
    '/services/dedicated-servers',
    '/services/web-hosting',
    '/services/ripe-lir',
    '/services/ip-transit',
    '/services/colocation',
    '/services/managed-hosting',
    '/services/remote-hands',
    '/game-server',
    '/company',
    '/network/ddos-protection',
    '/network/peering',
    '/network/sla',
    '/network/looking-glass',
    '/datacenter',
    '/reseller',
    '/legal',
];

/** Paths where canonical should always point to English (untranslated content). */
export function isEnglishOnlyCanonicalPath(path = '/') {
    const base = String(path).replace(/\/+$/, '') || '/';
    if (base === '/blog' || base.startsWith('/blog/')) {
        return true;
    }
    // Under-construction network tools (noindex) — avoid empty locale shells.
    if (base === '/network/smokeping' || base === '/network/uptime') {
        return true;
    }
    // Country doorways: EN canonical only (templates, not fully localized bodies).
    if (/^\/services\/vps-kvm\/[^/]+-kvm-vps$/.test(base)) {
        return true;
    }
    if (/^\/services\/dedicated-servers\/[^/]+-dedicated-servers$/.test(base)) {
        return true;
    }
    // Webhosting utility pages — never index.
    if (base.startsWith('/webhosting/domain-')) {
        return true;
    }
    return false;
}

export function isFullyTranslatedPath(path = '/') {
    const base = stripLocaleFromPathname(path);
    if (base === '/') {
        return true;
    }
    if (base.startsWith('/blog')) {
        return false;
    }
    return FULLY_TRANSLATED_PREFIXES.some(
        (prefix) => prefix !== '/' && (base === prefix || base.startsWith(`${prefix}/`)),
    );
}

export function resolveCanonicalLocale(path, activeLocale) {
    if (isEnglishOnlyCanonicalPath(path)) {
        return DEFAULT_LOCALE;
    }
    return activeLocale;
}

/** Non-English locale URLs with English-only body content should not be indexed. */
export function shouldNoindexForLocale(path, activeLocale) {
    if (activeLocale === DEFAULT_LOCALE) {
        return false;
    }
    if (isEnglishOnlyCanonicalPath(path)) {
        return true;
    }
    return !isFullyTranslatedPath(path);
}
